<template>
    <div>
        <form-base v-on="$listeners" v-if="!isCard" :value="value" :filter="filter" :hide-delete="hideDelete" :readonly="readonly" :hide-offset="hideOffset" :api-method="apiMethod" :fields="fields" :form-title="formTitle" :is-hover="isHover" />
        <card-base v-on="$listeners" v-if="isCard" :item="value" :filter="filter" :card-color="cardColor" :readonly="readonly" :fields="fields" :title="formTitle" />
    </div>
</template>

<script>
    export default {
        props: [
            'value',
            'filter',
            'hideDelete',
            'readonly',
            'hideOffset',
            'isCard',
            'cardColor',
            'isHover'
        ],

        components: {
            formBase: () => import('../components/FormBase'),
            cardBase: () => import('../components/CardBase')
        },

        data() {
            return {
                blendForm: () => import('../forms/BlendForm'),
                blendSupplierForm: () => import('../forms/BlendSupplierForm'),
                staffMemberForm: () => import('../forms/StaffMemberForm'),
                fields: [
                    { type: 'autocomplete', text: 'Blend', value: 'blendId', rules: [v => !!v || 'Blend is required'], isRequired: true, form: () => import('./BlendForm'), apiMethod: 'Blends', claim: 'Blends' },
                    { type: 'autocomplete', text: 'Blend Supplier', value: 'blendSupplierId', rules: [v => !!v || 'Blend Supplier is required'], isRequired: true, form: () => import('./BlendSupplierForm'), apiMethod: 'BlendSuppliers', claim: 'BlendSuppliers' },
                    { type: 'datetime', text: 'Received On', value: 'receivedOn', rules: [v => !!v || 'Received On is required'], isRequired: true },
                    { type: 'number', text: 'Price', value: 'price', rules: [] },
                    { type: 'text', text: 'Delivery Company', value: 'deliveryCompany', rules: [v => !(v && v.length > 100) || 'Delivery Company must be less than 100 characters'], maxLength: 100 },
                    { type: 'autocomplete', text: 'Checked By Staff Member', value: 'checkedByStaffMemberId', rules: [], form: () => import('./StaffMemberForm'), apiMethod: 'StaffMembers', claim: 'StaffMembers' },
                ],
                apiMethod: 'BlendReceivals',
                formTitle: 'Blend Receival',
            }
        },
    };
</script>
